import {
  FETCH_CONTEST_LIST,
  FETCH_CONTEST,
  CONTEST_TOGGLE_LOADING,
  UNAUTHORIZED_CONTEST,
} from "../../constants/ActionTypes";

const initialState = {
  loading: false,
  contestList: null,
  contest: null,
  unauthorizedContest: null,
};

const contestReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CONTEST_TOGGLE_LOADING:
      return { ...state, loading: payload };
    case FETCH_CONTEST_LIST:
      return { ...state, contestList: payload };
    case FETCH_CONTEST:
      return { ...state, contest: payload };
    case UNAUTHORIZED_CONTEST:
      return { ...state, unauthorizedContest: payload };
    default:
      return state;
  }
};

export default contestReducer;
